import { render, staticRenderFns } from "./OrderDetailBancolombia.vue?vue&type=template&id=7ff00df6"
import script from "./OrderDetailBancolombia.vue?vue&type=script&lang=js"
export * from "./OrderDetailBancolombia.vue?vue&type=script&lang=js"
import style0 from "./OrderDetailBancolombia.vue?vue&type=style&index=0&id=7ff00df6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports